/* Handling all the Core String constatnts from here */
export class Constants {
    public static RECENT_ORDER = 'recent'; 
    public static GUEST_SIGNUP='guest-sign-up';
    public static NO_INTERNET_FRAGMENT = '/nointernet';
    public static MENU_NOT_AVAILABLE = 'menunotavailable';
    public static RETURN_URL = 'returnurl';
    public static FORWARD_URL = 'forwardurl';
    public static ORDER_SUMMARY = 'ordersummary';
    public static VERIFY_EMAIL = 'verifyemail';
    public static APPLE_SIGNIN_ORIGIN = 'applesigninorigin';
    public static SIGNIN = 'signin';
    public static REGISTER = 'register';
    public static CATEGORY_ID = 'categoryid';
    public static UNIT_NUMBER = 'unitnum';
    public static LOCATION_ID = 'locid';
    public static ORDER_ID = 'orderid';
    public static FAVORITE_ID = 'favoriteid';
    public static ID = 'id';
    public static PARENT_RECIPE_ID = 'parentrecipeid';
    public static GUEST_ID = 'guestid';
    public static ADDRESS_ID = 'addressid';
    public static GUEST_ORDER = 'guestorder';
    public static CANCELLED_BY_SYSTEM = 'cancelledbysystem';
    public static AUTOMATIC_DELIVERY_LOCATION = 'automaticdeliverylocation';
    public static LOCATION_CLOSED = 'locationclosed';
    public static CANCELLED_BY_USER_FOR_EDIT='cancelledbyuserforedit';
    public static ORDER_STATUS_MSG = 'orderstatusmsg';
    public static USER_TYPE = 'usertype';
    public static SUCCESS =  'success';
    public static CANCELLED = 'cancelled';
    public static SHOW_CART = 'showcart';
    public static SEARCH = 'search';
    public static GUEST_ORDER_ID = 'guestorderid';
    public static REWARDS_ANCHOR = 'rewardsanchor';
    public static FAVORITE_FLAG = 'favoriteflag';
    public static DELIVERY_ADDRESS_CHANGE = 'deliveryaddresschange';
    public static PAGE_ID = 'pageid';
    public static CAT_ID = 'catid';
    public static P_RECIPE_ID = 'precipeid';
    public static RECIPE_ID = 'recipeid';
    public static RECIPE_TYPE_ID ='recipetypeid';
    public static SPECIAL_OPTIONS = 'splopt';
    public static RELOAD = 'reload';
    public static GUEST_ORDER_GUID = 'guestorderguid';
    public static GUEST = 'guest';
    public static ROUTE_ON_POINTS = 'routeonpoints'
    public static CARD_ID = 'cardid';
    public static TRANSFER = 'transfer';
    public static ACCESS_TOKEN ='access_token';
    /** Apple JWT from IdP redirect; passed to CX `signup_external` as `idToken` for Auth0 CTE. */
    public static ID_TOKEN = 'id_token';
    public static NONCE = 'nonce';
    public static SOURCE = 'source';
    public static INDEX = 'index';
    public static REWARDS = 'rewards';
    public static REWARD_ITEM_ID = 'itemid';
    public static LINKED_RECIPE ="linked";
    public static LINKED_RECIPE_ID ="linkedrecipeid";
    public static ORDER_ITEM_ID ="orderitemid";
    public static SELECTED_QUANTITY="%SelectedQuantity%";
    public static MAXIMUM_QUANTITY="%MaximumQuantity%";
    public static MINIMUM_QUANTITY="%MinimumQuantity%";
    public static TYPE = "type";
    public static START_CHAT = 'startchat';
}